import keyMirror from 'keymirror';

export const sharedTypes = keyMirror({
	LOGIN_REQUEST: null,
	LOGIN_SUCCESS: null,
	LOGIN_ERROR: null,
	SEND_EVENT_REQUEST: null,
	SEND_EVENT_SUCCESS: null,
	SEND_EVENT_ERROR: null,
	SET_AUDIO_ON: null,
});
